<template>
  <ModalStructure
    class="oidcConfirmationModalStructure"
    :shouldCloseOnBlur="false"
    :showCloseButton="false"
    :showModal="true"
    @close="closeModal"
  >
    <template v-slot:header>
      <HeadingMedium>
        Application Saved
      </HeadingMedium>
    </template>
    <template v-slot:body>
      <div>
        <ParagraphBody>
          {{ helperText }}
        </ParagraphBody>
        <CopyWell
          ref="copyClientId"
          ariaLabel="Client ID"
          class="oidcCopyWell"
          label="Client ID"
          name="client-id"
          :value="clientID"
        />
        <CopyWell
          v-if="clientSecret"
          ref="copyClientSecret"
          ariaLabel="Client Secret"
          class="oidcCopyWell"
          label="Client Secret"
          name="client-secret"
          :value="clientSecret"
        />
        <NotificationInPage
          v-if="clientSecret"
          :notification="notificationConfig"
        />
      </div>
    </template>
    <template v-slot:footer>
      <Button
        hasOutline
        text="Got it"
        type="secondary"
        @click="closeModal"
      />
    </template>
  </ModalStructure>
</template>

<script>
import {
  Button,
  CopyWell,
  HeadingMedium,
  ModalStructure,
  NotificationInPage,
  ParagraphBody,
  Types,
} from '@jumpcloud/ui-components';

export default {
  name: 'OidcConfigConfirmationModal',

  components: {
    Button,
    CopyWell,
    HeadingMedium,
    ModalStructure,
    NotificationInPage,
    ParagraphBody,
  },

  props: {
    clientID: {
      required: true,
      type: String,
    },
    clientSecret: {
      default: '',
      required: false,
      type: String,
    },
    notificationMarkdown: {
      default: 'The Client Secret is like a password and should not be shared with anyone. The client secret can only be viewed and copied from this window and can\'t be accessed after clicking **Got It** below.',
      type: String,
    },
  },

  computed: {
    helperText() {
      return `The Client ID${this.clientSecret ? ' and Client Secret' : ''} may be required when configuring the service provider.`;
    },

    notificationConfig() {
      return new Types.NotificationConfig({
        icon: 'error',
        isMarkdown: true,
        message: 'The Client Secret is like a password and should not be shared with anyone. The client secret can only be viewed and copied from this window and can\'t be accessed after clicking **Got It** below.',
        showCloseButton: false,
        title: 'Client Secret Warning',
        type: 'warning',
      });
    },
  },

  methods: {
    closeModal() {
      this.$emit('close');
    },
  },
};
</script>

<style scoped>
.oidcConfirmationModalStructure {
  text-align: left;
}

.oidcConfirmationModalStructure >>> *[class*="ModalContainer__modal"] {
  width: 36rem;
}

.oidcCopyWell:last-child {
  margin-bottom: var(--jc-spacer);
}
</style>
